<template>
  <div class="redbox" v-if="hbAlertState">
    <div class="redbox-con">
      <img src="//i0.ulecdn.com/i/event/2019/0919/main/images/bg2.png" alt />
      <img
        alt
        class="img2 test-lazyload"
        src="//i0.ulecdn.com/i/event/2019/0919/main/images/maintitle.png"
      />
      <img
        alt
        class="img3 test-lazyload"
        src="//i0.ulecdn.com/i/event/2019/0919/main/images/garnary2.png"
      />
      <img
        alt
        class="img4 test-lazyload"
        src="//i0.ulecdn.com/i/event/2019/0919/main/images/btn.png"
      />
      <img alt class="img5 test-lazyload" :src="imgSrc" />
      <a data-stat="切红包提示层点击关闭" href="javascript:void(0);" @click="close" class="rem"></a>
      <a data-stat="切红包提示层点击" href="javascript:void(0);" @click="hbGame" class="go"></a>
    </div>
  </div>
</template>  

<script>
import Vue from "vue";
import * as URL from "../../assets/js/url.js";
export default {
  props: ["sysTime", "isLogin", "redactivityCode"],
  data() {
    return {
      hbAlertState: true, //红包雨弹框状态
      redimgdata: "",
      code: "MA_U_156566221239936", //切红包活动code
      href:
        "//www." + URL.doMain + "/event/2019/0919/cutredbag/index.html?codeid="
    };
  },
  created() {
    this.init();
  },
  computed: {
    imgSrc() {
      return (
        "//i1.ulecdn.com/i/event/2018/0511/nineh/redbox/re" +
        this.redimgdata +
        ".png"
      );
    }
  },
  methods: {
    close() {
      this.hbAlertState = false;
      this.$emit("closeAlert", false);
    },
    init() {
      var m = this;
      if (m.sysTime.getDate() == 19) {
        if (m.sysTime.getHours() == 0) {
          m.redimgdata = "0";
        } else if (m.sysTime.getHours() == 9) {
          m.redimgdata = "10";
        } else {
          m.redimgdata = "9";
        }
      } else {
        if (m.sysTime.getHours() > 12 && m.sysTime.getHours() < 20) {
          m.redimgdata = "x";
        } else if (m.sysTime.getHours() >= 20) {
          m.redimgdata = "w";
        }
      }
    },
    hbGame() {
      if (!this.isLogin) {
        this.login();
        return;
      }
      console.log(this.redactivityCode);
      location.href = this.href + this.redactivityCode;
    },
    login() {
      if (this.BASE.$browser().ule) {
        location.href = "uleMobile://uleLogin_" + location.href;
      } else {
        location.href =
          "//m." +
          URL.doMain +
          "/user/login?target=" +
          encodeURIComponent(location.href);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.redbox {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 9999;
}
/* 切红包通知弹层 */
.redbox .redbox-con {
  width: 90.666%;
  max-width: 580px;
  position: absolute;
  left: 50%;
  top: 45%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.redbox .redbox-con img {
  display: block;
  width: 100%;
}
.redbox .redbox-con .img2,
.redbox .redbox-con .img3,
.redbox .redbox-con .img4,
.redbox .redbox-con .img5 {
  display: block;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -moz-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  -o-transform: translateX(-50%);
  transform: translateX(-50%);
}
.redbox .redbox-con .img2 {
  width: 77.0588%;
  top: 8.93%;
  z-index: 3;
}
.redbox .redbox-con .img3 {
  width: 94.647%;
  top: 38.56%;
  z-index: 2;
}
.redbox .redbox-con .img4 {
  width: 94.647%;
  top: 68.68%;
  z-index: 4;
}
.redbox .redbox-con .img5 {
  width: 77.206%;
  top: 36.63%;
  z-index: 5;
}
.redbox .redbox-con .rem {
  background: url(//i0.ulecdn.com/i/event/2019/0919/main/images/btn-close.png)
    no-repeat center;
  background-size: 100% 100%;
  position: absolute;
  top: 0.2rem;
  right: 0.18rem;
  width: 0.72rem;
  height: 0.72rem;
  z-index: 7;
}
.redbox .redbox-con .go {
  width: 52%;
  height: 11%;
  position: absolute;
  bottom: -2.6%;
  left: 24%;
  z-index: 6;
}
</style>



// WEBPACK FOOTER //
// src/components/common/alert-yinbao.vue